(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/betslip/betslip-payoptions.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/betslip/betslip-payoptions.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.BetslipPayOptions = Marionette.View.extend({
    modelEvents: {
      change: 'render'
    },

    className: 'view-betslip-content betslip-content-content betslip-expanded',

    template: function(data) {
      return svs.matchen.templates.betslip_payoptions(data);
    },

    initialize: function() {
      this.timeoutsCache = {}; 

      _.bindAll(this, 'onBetAmountChanged', 'onValidationChanged');
    },

    onRender: function() {
      var betAmounts = this.$('.bet-amounts');

      new svs.sport.BetAmountPicker(betAmounts, {
        betAmounts: [10, 20, 50, 100],
        currentBetAmount: this.model.get('betAmount'),
        isValid: this.model.get('isValidBetAmount'),
        minAmount: 10,
        buttonSize: 200,
        errorStyleInverted: false,
        buttonCSSClass: 'btn-toggle-betslip-matchen',
        onBetAmountChanged: this.onBetAmountChanged,
        onValidationChanged: this.onValidationChanged
      });
      this.updateSize();
    },

    updateSize: function() {
      setTimeout(function() {
        if (svs.matchen.views.betslip) {
          svs.matchen.views.betslip.changeSize();
        }
      }, 0);
    },
    onBetAmountChanged: function(betAmount) {
      this.model.set({
        betAmount: betAmount,
        totalCost: this.model.getNumberOfRows() * betAmount
      });
    },

    onValidationChanged: function(isValid, betAmount) {
      this.model.set({
        betAmount: betAmount,
        totalCost: this.model.getNumberOfRows() * betAmount
      });
    },

    onDestroy: function() {
      this.clearTimeouts();
    },

    clearTimeouts: function() {
      _.each(_.values(this.timeoutsCache), function(timeout) {
        window.clearTimeout(timeout);
      });

      this.timeoutsCache = {};
    }
  });
})(Backbone, _, svs);


 })(window);